"use client";

import { useEffect, useState } from "react";
import Script from "next/script";
import { getCookie } from "cookies-next";

interface ConsentState {
  functional: boolean;
  analytics: boolean;
}

interface CookieConsent {
  hasConsented: boolean;
  consent: ConsentState;
  timestamp: string;
}

export default function ConditionalScripts() {
  const [consent, setConsent] = useState<ConsentState>({
    functional: true,
    analytics: false,
  });

  useEffect(() => {
    // Function to load consent from cookie
    const loadConsent = () => {
      const savedConsent = getCookie("cookie_consent");

      if (savedConsent) {
        try {
          const parsed: CookieConsent = JSON.parse(savedConsent as string);

          setConsent(parsed.consent);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error("Error reading consent:", error);
        }
      }
    };

    // Load initial consent
    loadConsent();

    // Listen for consent updates
    const handleConsentUpdate = (event: CustomEvent) => {
      setConsent(event.detail);
    };

    window.addEventListener(
      "cookieConsentUpdated",
      handleConsentUpdate as EventListener,
    );

    return () => {
      window.removeEventListener(
        "cookieConsentUpdated",
        handleConsentUpdate as EventListener,
      );
    };
  }, []);

  return (
    <>
      {/* Analytics consent available for custom tracking */}
      {consent.analytics && (
        <Script id="analytics-consent" strategy="afterInteractive">
          {`
            // Analytics consent granted - you can add custom tracking here
            //console.log('📊 Analytics consent granted - server-side tracking enabled');
          `}
        </Script>
      )}

      {/* Functional scripts - always load */}
      <Script id="functional-scripts" strategy="afterInteractive">
        {`
          // Scripts required for site functionality
          //console.log('⚙️ Functional scripts loaded');
        `}
      </Script>
    </>
  );
}
